import { secrets } from './secrets';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	recaptchaKey: secrets.recaptchaKey,
	apiUrl: 'https://develop-app.cameconnect.net/api',
	apiUrlThermo: 'https://develop-thermo.cameconnect.net',
	websocketUrl: 'wss://develop-app.cameconnect.net/api/events-real-time',
	websocketUrlThermo: 'wss://develop-thermo.cameconnect.net:8443/WebSocket',
	oldFrontEnd: 'https://app-develop-legacy.cameconnect.net',
	frontEnd: 'https://app-develop.cameconnect.net',
	googleAPI: secrets.googleAPI,
	clientId: secrets.clientId,
	apiStatus: 'https://servicestatus.cameconnect.net/',
	statusEnv: 'develop',
	clientSecret: secrets.clientSecret,
	// Firebase
	firebase_apiKey: secrets.firebase_apiKey,
	firebase_authDomain: "cameconnect-analytics-v2.firebaseapp.com",
	firebase_projectId: "cameconnect-analytics-v2",
	firebase_storageBucket: "cameconnect-analytics-v2.firebasestorage.app",
	firebase_messagingSenderId: secrets.firebase_messagingSenderId,
	firebase_appId: secrets.firebase_appId,
	firebase_measurementId: secrets.firebase_measurementId
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
